interface DisbursementPayload {
    disbursements?: Array<{ date: string; amount: number }>;
}

interface InstallmentPayload {
    items?: Array<{
        value: number;
        dueDate: string;
        format: string;
        business_reference?: string;
        document_id?: string;
        document_title?: string;
        receivable_installment?: string;
        debtor_name?: string;
        debtor_cpf_cnpj?: string;
    }>;
}

interface FeesPayload {
    items?: Array<{
        description?: string;
        name?: string;
        rate: number;
        value: number;
        form: string;
        interest_period: string;
    }>;
}

export const formatDateISO = (dateStr: string): string => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
};

export const formatDisbursements = (disbursement: DisbursementPayload | undefined) => {
    return disbursement?.disbursements?.map((d) => ({
        date: formatDateISO(d.date),
        amount: d.amount
    })) || [];
};

export const formatInstallments = (installment: InstallmentPayload | undefined) => {
    return installment?.items?.map((inst, index) => ({
        number: index + 1,
        value: inst.value || 0,
        dueDate: formatDateISO(inst.dueDate),
        format: inst.format || 'VALOR',
        business_reference: inst.business_reference || '',
        document_id: inst.document_id || '',
        document_title: inst.document_title || '',
        receivable_installment: inst.receivable_installment || '',
        debtor_name: inst.debtor_name || '',
        debtor_cpf_cnpj: inst.debtor_cpf_cnpj || '',
    })) || [];
};

export const formatFees = (fees: FeesPayload | undefined) => {
    return fees?.items?.map((fee) => ({
        name: fee.description || fee.name || '',
        rate: fee.rate || 0,
        amount: fee.value || 0,
        form: fee.form || '',
        interest_period: fee.interest_period || ''
    })) || [];
};

export const getCurrentDate = (): string => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
};

export const formatHarvestYear = (value: string): string => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 2) return numbers;
    return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}`;
};

export const formatISOToDate = (isoDate: string): string => {
    if (!isoDate) return getCurrentDate();
    const dateOnly = isoDate.split('T')[0];
    const [year, month, day] = dateOnly.split('-');
    return `${day}/${month}/${year}`;
};
